import React from 'react';
export function ProductInfo() {
  return <div className="max-w-3xl mx-auto px-4 py-4" data-id="element-114">
      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-115">
        The Formula Built for the Real Problem
      </h2>
      <p className="mb-6" data-id="element-116">
        Dan's naturopath recommended Glucora because it targets the mechanisms
        stress disrupts: cortisol response, metabolic signaling, cellular energy
        production.
      </p>
      <p className="mb-6" data-id="element-117">
        Most supplements force glucose down with brute force. Glucora supports
        the stress-glucose-energy balance that chronic pressure destroys.
      </p>
      <p className="mb-6" data-id="element-118">Here's what it's designed to help with:</p>
      <ul className="mb-6 space-y-4" data-id="element-119">
        <li className="flex items-start" data-id="element-120">
          <span className="text-green-600 mr-2" data-id="element-121">✓</span>
          <span data-id="element-122">
            <strong data-id="element-123">Stop stress from spiking your glucose</strong> — Rhodiola
            and Astragalus support healthy cortisol response, helping your body
            handle pressure without sending glucose through the roof.
          </span>
        </li>
        <li className="flex items-start" data-id="element-124">
          <span className="text-green-600 mr-2" data-id="element-125">✓</span>
          <span data-id="element-126">
            <strong data-id="element-127">End the afternoon energy crash</strong> — L-Carnitine and
            Maca support energy production at the cellular level—no stimulants,
            no jitters, just steady fuel all day.
          </span>
        </li>
        <li className="flex items-start" data-id="element-128">
          <span className="text-green-600 mr-2" data-id="element-129">✓</span>
          <span data-id="element-130">
            <strong data-id="element-131">Restore metabolic function that slows with age</strong> —
            African Mango supports leptin sensitivity—leptin is the master
            hormone that regulates your metabolism. When leptin signaling
            improves, your body responds to glucose more effectively.
          </span>
        </li>
        <li className="flex items-start" data-id="element-132">
          <span className="text-green-600 mr-2" data-id="element-133">✓</span>
          <span data-id="element-134">
            <strong data-id="element-135">Stay sharp under pressure</strong> — The amino acid blend
            (L-Arginine, L-Glutamine, L-Ornithine) supports healthy blood flow
            and cognitive function when you need to perform.
          </span>
        </li>
      </ul>
      <p className="mb-6" data-id="element-136">
        Unlike high-dose Berberine—which gave Dan the same stomach problems as
        Metformin—Glucora's targeted formula was gentler and addressed root
        mechanisms, not just symptoms.
      </p>
      <p className="mb-6" data-id="element-137">
        "This is designed for guys still in the game," Dan said. "Who need to
        stay sharp all day, not just see a lower lab number."
      </p>
      <p className="mb-6" data-id="element-138">
        For the first time in months, I felt something shift. Not hype. Not
        desperation.
      </p>
      <p className="mb-6" data-id="element-139">Just logic.</p>
      <p className="mb-6" data-id="element-140">
        This finally explained why nothing else had worked.
      </p>
      <div className="mt-8 mb-10 flex justify-center" data-id="element-141">
        <a href="https://seravaco.shop/products/glucora%E2%84%A2-metaboshield%E2%84%A2?variant=47313966498019" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300" data-id="element-142">
          Try Glucora today
        </a>
      </div>
      <div className="my-8" data-id="element-143">
        <img src="https://cdn.magicpatterns.com/uploads/iH8mtmbKiG9q3AQk4oAa7w/gemini-generated-image-4h9hkw4h9hkw4h9h.jpg" alt="Glucora supplement bottle" className="w-full h-auto rounded-lg shadow-md" data-id="element-144" />
        <p className="text-center text-sm text-gray-500 mt-2" data-id="element-145">
          After 60 days, I had energy I hadn't felt in years
        </p>
      </div>
      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-146">My First 60 Days</h2>
      <p className="mb-4" data-id="element-147">
        <span className="font-bold" data-id="element-148">Week 1-2:</span> The 3 PM crashes stopped.
        Not "got better"—stopped. I finished meetings sharp. No fog. No
        desperate reach for another coffee.
      </p>
      <p className="mb-4" data-id="element-149">
        <span className="font-bold" data-id="element-150">Week 3-4:</span> Stress felt different.
        Still there, but it wasn't dragging me under. I could handle pressure
        without feeling wrecked afterward.
      </p>
      <p className="mb-4" data-id="element-151">
        <span className="font-bold" data-id="element-152">Week 6:</span> Fasting glucose dropped from
        112 to 99. Then 97. And stayed there.
      </p>
      <p className="mb-4" data-id="element-153">
        <span className="font-bold" data-id="element-154">Week 8:</span> My business partner pulled me
        aside. "I don't know what you're doing, but you're back. You're sharp
        again."
      </p>
      <p className="mb-6" data-id="element-155">
        By week 10, I was finishing workdays with energy left. Not collapsing at
        6 PM. Cooking dinner. Going for walks. Feeling like myself.
      </p>
      <p className="mb-6" data-id="element-156">My wife noticed: "You're present again."</p>
      <div className="my-8" data-id="element-157">
        <img src="https://cdn.magicpatterns.com/uploads/vsbiLLGc7gs2WB4BNYmSxB/30-day-risk-free-trial-7.png" alt="Glucora supplement bottle with 90-day risk-free trial badge" className="w-full h-auto rounded-lg shadow-md" data-id="element-158" />
        <p className="text-center text-sm text-gray-500 mt-2" data-id="element-159">
          After 90 days, I had energy I hadn't felt in years
        </p>
      </div>
      <h2 className="text-xl font-bold mt-10 mb-6" data-id="element-160">
        Why This Matters More Than You Think
      </h2>
      <p className="mb-6" data-id="element-161">This isn't just about blood sugar.</p>
      <p className="mb-6" data-id="element-162">
        It's about staying sharp in the moments that matter. Not losing your
        edge to younger colleagues. Finishing the day with energy for the people
        you care about.
      </p>
      <p className="mb-6" data-id="element-163">
        It's about protecting your independence, your competence, your identity
        as someone who still shows up and delivers.
      </p>
      <p className="mb-6" data-id="element-164">
        When you're 62 and still grinding, you can't afford brain fog in client
        meetings. You can't afford to feel like you're falling behind. You can't
        afford to lose the respect you've spent decades building.
      </p>
      <p className="mb-6" data-id="element-165">Glucora gave me my edge back.</p>
      <div className="my-8" data-id="element-166"></div>
    </div>;
}